<template>
  <component :is="element" :class="classes">
    <!-- @slot Slot for heading content. -->
    <slot />
  </component>
</template>

<script>
export default {
  name: 'PdlHeading',
  props: {
    /**
     * The heading level (1-6), which corresponds to the `<h1>` to `<h6>` section heading elements. If no level is defined, a `<p>` tag will be used.
     */
    level: {
      type: [Number, String],
      default: undefined,
    },
    /**
     * Size of heading (`xxl`, `xl`,`lg`, `md`, & `sm`), which determines heading font size.
     */
    size: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    element() {
      return this.level ? `h${this.level}` : 'p';
    },
    sizeClass() {
      return `pdl-heading--${this.size}`;
    },
    classes() {
      return {
        'pdl-heading': true,
        [this.sizeClass]: this.size,
      };
    },
  },
};
</script>

<style lang="scss">
@import 'SectionHeader.scss';
</style>
